<template>
  <div class="search-result__inner">
    <!-- <div class="search-result__taxonomy">
      <div class="badge">Undergraduate course</div>
    </div> -->
    <div class="search-result__new-course" v-if="isNewCourse">
      <img alt="new-course-icon" src="../assets/new-icon.svg" />
      <p>New course</p>
    </div>
    <div class="search-result__main">
      <h1>{{ getFieldValue(result.Fields, 'ProgrammeTitle') }}</h1>
      <p
        v-html="getFieldValue(result.Fields, 'Description', 'Unknown', true)"
      ></p>
    </div>
    <div class="search-result__meta">
      <dl>
        <dt>Study type</dt>
        <dd>
          {{ capitalise(getFieldValue(result.Fields, 'StudyModes')) }}
        </dd>
        <dt>Course length</dt>
        <dd>
          {{ courseLength }}
        </dd>
        <dt>UCAS code</dt>
        <dd>
          {{ getFieldValue(result.Fields, 'UCASCode') ?? 'Not applicable' }}
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchResult',
  props: {
    result: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fullTimeLength() {
      return (
        Number(this.getFieldValue(this.result.Fields, 'FullTimeLength')) ||
        this.getFieldValue(this.result.Fields, 'FullTimeLength')
      );
    },
    partTimeLength() {
      return (
        Number(this.getFieldValue(this.result.Fields, 'PartTimeLength')) ||
        this.getFieldValue(this.result.Fields, 'PartTimeLength')
      );
    },
    courseLength() {
      if (this.fullTimeLength && this.partTimeLength) {
        return `${this.getYears(
          this.fullTimeLength
        )} full-time, ${this.getYears(this.partTimeLength)} part-time`;
      } else if (this.partTimeLength) {
        return `${this.getYears(this.partTimeLength)}`;
      } else {
        return `${this.getYears(this.fullTimeLength)}`;
      }
    },
    isNewCourse() {
      return this.getFieldValue(this.result.Fields, 'NewCourse') === 'Yes'
        ? true
        : false;
    },
  },
  methods: {
    getFieldValue(
      fields,
      fieldName,
      defaultValue = undefined,
      returnHighlights = false
    ) {
      // Assign field to a constant
      const field = fields[fieldName];
      // Verify that the field exists
      if (field) {
        // Assign field value to variable so it can be trimmed
        let fieldValue = field.Value;
        // Initialise field higlights with trimmed field value
        let fieldHighlights = fieldValue;
        // Verify that highlights exist on this field
        if (field.Highlights && field.Highlights.length > 0) {
          // Update field higlights to the first highlight only
          fieldHighlights = field.Highlights.join(' ');
        }
        // Return trimmed field value or joined highlights
        return returnHighlights ? fieldHighlights : fieldValue;
      }
      // The field does not exist, return the default string
      return defaultValue;
    },
    capitalise(string = '') {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getYears(yearLength) {
      return `${yearLength} year${yearLength !== 1 ? 's' : ''}`;
    },
  },
};
</script>

<style></style>
